module.exports = __webpack_public_path__ + "static/media/student_view_search_video.7e88f64c.mov";